import { Carousel } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

import { CustomCarouselRef } from '../HomePage/BookLibrary/Booklist';
import { ShouldRender } from '../shared/basic/ShouldRender';
import { formateErrorObject } from '../shared/formateErrorObject';
import { notify } from '../shared/notify';
import { getRewardRulesByName } from '../../services/reward';
import { Book_3D, checkoutCardBg, StartingPage } from '../../../assets';

type CardData = Record<number, [string, string]>;

const PersonalityStart: React.FC = () => {
  const [coins, setCoins] = useState(0);
  const tabs = ['Time', 'Cognition', 'Style', 'Motivation'];
  const [activeTab, setActiveTab] = useState(0);
  const carouselRef = useRef<CustomCarouselRef | null>(null);

  const cardData: CardData = {
    0: ['Constraint', 'Patient'],
    1: ['Analytical', 'Emotional'],
    2: ['Browsing', 'Skimming'],
    3: ['Motivated', 'Forced'],
  };

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    carouselRef.current?.goTo(index);
  };

  const screens = useBreakpoint();
  const handleRewardCoin = async () => {
    try {
      const data = await getRewardRulesByName('personality_test_complete');
      setCoins(data.data);
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';

      notify(message, 'error');
    }
  };
  useEffect(() => {
    handleRewardCoin();
  }, []);

  const handleSlideChange = (currentIndex: number) => {
    setActiveTab(currentIndex);
  };

  return (
    <div className='flex justify-center'>
      <div className='flex flex-col gap-y-1.5 md:gap-y-4'>
        <span className='text-base text-primary   flex justify-center text-center font-semibold '>
          15-min Quiz
        </span>
        <div className='flex justify-center items-center'>
          <div className='text-white text-xl md:text-2xl flex font-semibold text-center w-4/5 md:w-3/5 md:px-10'>
            Know yourself better, with this one quiz
          </div>
        </div>

        <div className='flex justify-start gap-x-3 py-4'>
          <div className='flex flex-col'>
            {/* Tabs Header */}

            {/* Carousel */}
            <div
              className={clsx(
                'relative w-full max-w-[90vw] py-1 md:py-4 px-3 md:px-6 md:max-w-[450px]  rounded-xl overflow-hidden',
              )}
              style={{
                border: '1px solid #1C1C1C',
              }}
            >
              <div className='flex gap-x-2 md:gap-4 py-4 w-full justify-between'>
                {tabs.map((tab, index) => (
                  <div
                    key={tab}
                    onClick={() => handleTabClick(index)}
                    className={clsx(
                      'text-xs md:text-sm font-medium  md:tracking-widest cursor-pointer uppercase rounded-md ',
                      activeTab === index ? 'text-white' : 'text-[#3C3B3E]',
                    )}
                  >
                    {tab}
                  </div>
                ))}
              </div>

              <Carousel
                initialSlide={activeTab}
                ref={carouselRef}
                afterChange={handleSlideChange}
                autoplay
                className='flex rounded-xl pt-3 pb-10'
                dotPosition='bottom'
              >
                {Object.keys(cardData).map((key, index) => {
                  const data = cardData[+key];
                  if (!data) return null;

                  return (
                    <div
                      key={index}
                      className='flex justify-between  items-center w-full  '
                    >
                      <span
                        className='min-h-[160px] md:min-h-[190px] w-full rounded-lg flex justify-center items-center'
                        style={{
                          background:
                            'linear-gradient(180deg, #151515 0%, #000000 100%)',
                          border: '1px solid #1C1C1C',
                        }}
                      >
                        <div className='flex flex-col justify-center gap-y-2 items-center'>
                          <span className='bg-[#282829] p-4 text-xl font-bold rounded-full w-10 h-10 flex justify-center items-center'>
                            {data[0][0]}
                          </span>
                          <span className='text-sm font-semibold'>
                            {' '}
                            {data[0]}
                          </span>
                        </div>
                      </span>
                      <span className='italic text-[#9F9EA6] px-2 md:px-8 text-xs w-10 h-10 flex justify-center items-center'>
                        or
                      </span>
                      <span
                        className='min-h-[160px] md:min-h-[190px] w-full rounded-lg flex justify-center items-center'
                        style={{
                          background:
                            'linear-gradient(180deg, #151515 0%, #000000 100%)',
                          border: '1px solid #1C1C1C',
                        }}
                      >
                        <div className='flex flex-col justify-center gap-y-2 items-center'>
                          <span className='bg-[#282829] p-4 text-xl font-bold rounded-full w-10 h-10 flex justify-center items-center'>
                            {data[1][0]}
                          </span>
                          <span className='text-sm font-semibold'>
                            {' '}
                            {data[1]}
                          </span>
                        </div>
                      </span>
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
          <ShouldRender check={screens.md}>
            <div
              style={{
                boxShadow:
                  '0px 2px 0px 0.5px #FFFFFF80 inset, 0px 2px 2px 0px #0000004F',
              }}
              className='relative overflow-hidden min-w-[250px] w-full pt-[3px] px-[3px] z-10 max-w-[250px] min-h-[300px] bg-bgColor border-dropDownMenuBg border rounded-xl'
            >
              <div className='h-full'>
                <div className='relative h-40 w-full'>
                  <Image
                    src={StartingPage}
                    alt='StartingPage'
                    layout='fill'
                    objectFit='cover'
                    className='absolute top-0 rounded-t-xl'
                  />
                  <div className='absolute inset-0 flex translate-y-6 items-center justify-center'>
                    <Image
                      src={Book_3D}
                      alt='Book_3D'
                      width={100}
                      height={100}
                      style={{
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </div>
                <div className='h-full'>
                  <h3 className='text-center text-xl font-semibold text-white'>
                    Get a free book
                  </h3>
                  <div className='flex justify-center '>
                    <p className='text-center text-textLightGray w-4/5 mt-2'>
                      You will be rewarded{' '}
                      <p className='text-white font-medium inline-flex'>
                        {coins} Z-coins
                      </p>{' '}
                      when you complete quiz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ShouldRender>
        </div>
        <ShouldRender check={!screens.md}>
          <div>
            <div className='w-full mt-6 '>
              <div
                className='bg-cartBgColor text-white px-2 p-3 md:p-6 flex  items-center relative rounded-2xl gap-3 md:gap-6'
                style={{
                  boxShadow:
                    '1px 1px 1px 0px #FFFFFF1A inset, 0px -1px 1px 0px #FFFFFF1A inset',
                }}
              >
                <Image
                  src={checkoutCardBg}
                  alt='checkoutCardBg'
                  className='absolute right-0 z-20 h-full rounded-r-2xl w-auto '
                  style={{
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
                <ShouldRender check={screens.md}>
                  <Image
                    src={checkoutCardBg}
                    alt='checkoutCardBg'
                    className='absolute left-0 rotate-180 z-20 h-full rounded-r-2xl w-auto '
                    style={{
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </ShouldRender>
                <div className='flex gap-x-1 items-center'>
                  <Image
                    src={Book_3D}
                    alt='Book_3D'
                    width={66}
                    height={90}
                    style={{
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
                  <div className='flex flex-col z-20 relative md:flex-row gap-y-3 w-full  justify-between items-center'>
                    <div className='flex  justify-center flex-col  text-left '>
                      <h2 className='text-sm font-semibold mb-1'>Reward</h2>
                      <p className='text-[10px] text-textLightGray  '>
                        You will be rewarded{' '}
                        <p className='text-white font-medium inline-flex'>
                          {coins} Z-coins
                        </p>{' '}
                        when you complete quiz.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default PersonalityStart;
